/**
 * external dependencies
 */
import { TabulatorFull } from 'tabulator-tables';

/**
 * Downloads the terminal list data as a csv file.
 * 
 * @param tableObject the table class instance containing the terminal list data
 * 
 * @returns void
 */
export const downloadTerminalListData = ( tableObject: TabulatorFull ): void => {
  const tableDownload = document.querySelector('#download-terminal-list-csv') as HTMLElement;
  const fileName = `terminal_${new Date().toLocaleDateString()}_download.csv`;

  // check if the download button exists due to user access
  if (tableDownload) {
    tableDownload.addEventListener('click', () => tableObject.download('csv', fileName));
  }
};